import {filterByUpmIds, getChildren} from '@widgets/report-filters'

import {UpmHierarchyNode} from '@refra/modules/common/types'
import {UpmDepartmentWithPlant, UpmFiltersState} from '@refra/modules/refra-flexible-report/types'

export const getAllKilns = (items: UpmHierarchyNode[]): string[] => {
  return items.flatMap((item) => {
    if (item.children?.length) {
      return getAllKilns(item.children)
    }

    return item.level === 'Department' ? [item.upmId] : []
  })
}

export const matchesAssetConfigFilter = (
  values: Record<string, string | undefined>,
  filters: Record<string, string[]>
) => {
  return Object.entries(filters).every(([key, allowedValues]) => {
    if (allowedValues.length === 0) return true

    const value = values[key]
    return value !== undefined && allowedValues.includes(value)
  })
}

export const parseHierarchy = (
  upmHierarchyData: UpmHierarchyNode[] | undefined,
  upmFilters: UpmFiltersState
) => {
  if (!upmHierarchyData) {
    return {managementAreas: [], countries: [], plants: [], departments: []}
  }

  const managementAreas = upmHierarchyData.filter((node) => node.level === 'ManagementArea') ?? []
  const visibleManagementAreas = filterByUpmIds(managementAreas, upmFilters.ManagementArea)

  const countries = getChildren(visibleManagementAreas)
  const visibleCountries = filterByUpmIds(countries, upmFilters.Country)

  const plants = getChildren(visibleCountries)
  const visiblePlants = filterByUpmIds(plants, upmFilters.Plant)

  const departments = getChildren(visiblePlants).flatMap((department) => department.upmId)

  return {managementAreas, countries, plants, departments}
}

export function collectDepartmentsWithPlant(
  nodes: UpmHierarchyNode[],
  currentPlantName?: string
): UpmDepartmentWithPlant[] {
  const result: UpmDepartmentWithPlant[] = []

  for (const node of nodes) {
    const plantName = node.level === 'Plant' ? node.value : currentPlantName

    if (node.level === 'Department' && plantName) {
      result.push({
        ...node,
        plantName
      })
    }

    if (node.children?.length) {
      result.push(...collectDepartmentsWithPlant(node.children, plantName))
    }
  }

  return result
}
